<script>
import ListMixin from '@/crudBases/list/ListMixin'
import { CampApplication } from '@/api'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Camp Application',
      verboseName: 'Camp application',
      verboseNamePlural: 'Camp applications',
      isPaginated: true,
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'student.first_name', label: "Student's first name" },
        { prop: 'student.last_name', label: "Student's last name" },
        { prop: 'status_display', label: 'Status' },
        { prop: 'package', label: 'Package' },
        { prop: 'duration', label: 'Duration (weeks)' },
        { prop: 'arrival', label: 'Arrival' }
      ],
      filters: {
        available: [
          {
            name: 'Status',
            query_param: 'status',
            options: [
              { label: 'Open', value: 'open' },
              { label: 'In progress', value: 'in_progress' },
              { label: 'Filled in', value: 'filled_in' },
              { label: 'Banking data', value: 'banking_data' },
              { label: 'Summary', value: 'summary' },
              { label: 'Completed', value: 'completed' },
              { label: 'Paid', value: 'paid' },
              { label: 'Processing', value: 'processing' },
              { label: 'Approved', value: 'approved' },
              { label: 'Unsuccessful', value: 'unsuccessful' },
              { label: 'Archived', value: 'archived' }
            ]
          }
        ]
      }
    }
  },
  computed: {
    service() {
      return CampApplication
    }
  }
}
</script>
